import { render, staticRenderFns } from "./EventsNinja.vue?vue&type=template&id=78d54070&scoped=true&"
import script from "./EventsNinja.vue?vue&type=script&lang=js&"
export * from "./EventsNinja.vue?vue&type=script&lang=js&"
import style0 from "./EventsNinja.vue?vue&type=style&index=0&id=78d54070&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d54070",
  null
  
)

export default component.exports